import { render, staticRenderFns } from "./Indata.vue?vue&type=template&id=5a51b1b5&style=height%3A%20100%25%3B"
import script from "./Indata.vue?vue&type=script&lang=js"
export * from "./Indata.vue?vue&type=script&lang=js"
import style0 from "./Indata.vue?vue&type=style&index=0&id=5a51b1b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports